import {Injectable} from '@angular/core';
import {IService} from '../IService';
import {PromotionDiscountTypeModel} from '../../models/promotion-discount-type.model';
import {HttpClientService} from '../httpClient/httpclient.service';

@Injectable()
export class PromotionDiscountTypeService extends IService<PromotionDiscountTypeModel> {
  constructor(
    http: HttpClientService
  ) {
    super(http, 'koncentro-promo', 'discount-type')
  }
}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-discount-type.service.ts